// Dashboard - primary page with analytics
import DashboardPage from "../views/Dashboard/Dashboard.jsx";

// To remove any of these from the backend
// (and consequently, the frontend as well)
// simply comment out their imports above
// and their corresponding object below

import {
  Dashboard,
} from "@material-ui/icons";

const appRoutes = [
  /* Main Dashboard */
  {
    path: "/dashboard",
    sidebarName: "Dashboard",
    navbarName: "Administrator Dashboard",
    icon: Dashboard,
    component: DashboardPage
  },
];

export default appRoutes;
